import { FunctionComponent } from "react";
import "./TooltipButton.scss";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: string;
  content?: string;
  tooltip?: string;
}

const TooltipButton: FunctionComponent<IProps> = (props) => {
  const getClasses = () => {
    const classes = [];

    classes.push("tooltip-button");
    classes.push(props.className);

    if (props.icon && !props.content) {
      classes.push("tooltip-button--icon-only");
    }

    return classes.join(" ");
  };

  return (
    <div className="tooltip-container">
      <button {...props} className={getClasses()}>
        {props.icon && <span className={"icon-" + props.icon}></span>}
        {props.content && <span>{props.content}</span>}
      </button>
      {props.tooltip && <span className="tooltip-text">{props.tooltip}</span>}
    </div>
  );
};

export default TooltipButton;